import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../context/PortalThemeContext';

const ThankYouScreen = ({ onRedirect }) => {

  const theme = useTheme();

  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      onRedirect();
    }, 4500);
    return () => clearTimeout(timer);
  }, [onRedirect]);

  const defaultMessage = "We've received your request and we’re on it.";
  const message = location?.state?.message;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      <Container
        style={{
          maxWidth: '490px',
          backgroundColor: '#FFFFFF',
          padding: '2rem',
          borderRadius: '8px',
          textAlign: 'center',
        }}
      >
        {/* Example checkmark icon */}
        <div style={{ fontSize: '48px', color: theme.primary, marginBottom: '1rem' }}>
          &#10003;
        </div>

        <h2
          style={{
            fontWeight: 700,
            fontSize: '28px',
            color: theme.primary,
            marginBottom: '0.5rem',
          }}
        >
          Thank you!
        </h2>

        <p
          style={{
            fontSize: '16px',
            color: theme.textDark,
          }}
        >
          {message || defaultMessage}
        </p>
      </Container>
    </div>
  );
};

export default ThankYouScreen;
